export default class FormAnimation {

    constructor() {
        
            this._animationDropdown()
            this._aanmeldenDropdown()
        
    }
    _animationDropdown() {
        let toggle = 0;   
        const ms = document.querySelector('.today-dropdown');
        if (typeof(ms) !== 'undefined' && ms !== null){
            ms.blur();
            const formDropdown = document.querySelector(".form-dropdown");
            ms.addEventListener("click", function(){           
                if(toggle === 0){
                    formDropdown.classList.add('dropTranslate'); 
                    toggle = 1; 
                }else if(toggle === 1){
                    formDropdown.classList.remove('dropTranslate');
                    toggle = 0;  
                }       
            });     
        }       
    }
    _aanmeldenDropdown() {
        let toggle = 0;   
        const e = document.querySelector(".meld-je-aan");
        if (typeof(e) !== 'undefined' && e !== null){
            const formDropdown = document.querySelector(".aanmeld-formulier-holder");
            document.querySelector(".meld-je-aan").addEventListener("click", function(){           
                if(toggle === 0){
                    formDropdown.classList.add('dropToggle');
                    e.classList.add('hiddenButton');
                    setTimeout(function(){e.classList.add('noHeightBtn')}, 300);
                    toggle = 1; 
                }    
            });     
        }       
    }
}